import { Form, InputGroup } from 'react-bootstrap';
import { todayISO } from '../../../utils/dateUtils';
import Required from '../../../utils/Required';

const EffectiveDateField = ({ value, onChange, isSubmitting }) => {
  return (
  <Form.Group>
    <InputGroup>
      <Form.FloatingLabel label={<Required>Effective Date</Required>} controlId="effective-date">
        <Form.Control
          type="date"
          value={value ?? ''}
          min={todayISO()}
          required
          disabled={isSubmitting}
          onChange={(e) => onChange(e.target.value)}
        />
        <Form.Control.Feedback type="invalid">
          Effective Date must be in the future.
        </Form.Control.Feedback>
      </Form.FloatingLabel>
      </InputGroup>
    </Form.Group>
  );
};

export default EffectiveDateField;